import ArrowBack from '@mui/icons-material/ArrowBack';
import { Button } from '@mui/material';
import React from 'react';
import { Link } from 'react-router-dom';

import { useLaunchPaths } from './paths';

export const BackToLaunches: React.FC = () => {
  const paths = useLaunchPaths();
  return (
    <Button component={Link} to={paths.list} startIcon={<ArrowBack />}>
      All launches
    </Button>
  );
};
